<template>
  <div class="weather">
    <div class="summary" v-if="currentWeather">
      <i class="weatherIcon"><img :src="populateWeatherIcon(currentWeather.json_object.weather)"></i>
      <div class="weatherText">
        <h3>{{ currentWeather.json_object.weather[0].description }}</h3>
        <h1>
          {{ calculateTemp }}<sup>&deg;{{ tempType }}</sup><small>in {{ allWeather.name}}</small></h1>
          <span class="scrolledDescriptionWrapper">
            Humidity | {{ currentWeather.json_object.main.humidity }} &#37;<br/>
            Wind | {{ calculateWind }} {{windType}}<br/>
            Pressure | {{ currentWeather.json_object.main.pressure }} hpa
          </span>
        </h1>
        <div class="fullDescriptionWrapper">
          Humidity {{ currentWeather.json_object.main.humidity }}&#37;<br/>
          Wind | {{ calculateWind }} {{windType}}<br/>
          Pressure | {{ currentWeather.json_object.main.pressure }} hpa
        </div>
      </div>
    </div>
    <div class="summary weatherLoader" style="display: none">
      <i class="weatherIcon"><img src="/static/img/weather/10d.svg"></i>
      <div class="weatherText">
        <h3>LIGHT RAIN</h3>
        <h1>
          24<sup>&deg;C</sup><small>in Pinetown</small></h1>
          <span class="scrolledDescriptionWrapper">
            Humidity | 100%<br/>
            Wind | 14 km/h<br/>
            Sea Level | 1017.95 hpa
          </span>
        </h1>
        <div class="fullDescriptionWrapper">
          Humidity | 100%<br/>
          Wind | 14 km/h<br/>
          Sea Level | 1017.95 hpa
        </div>
      </div>
    </div>
    <div class="forecast">
      <router-link class="btn viewMap" to="/map"><i class="icon-location"></i> View Map</router-link>
      <a class="btn btnForecast float-right" @click='toggleForecast()'>Forecast <i class="icon-down-open"></i></a>
      <transition name="slide" mode="out-in" :duration="{ enter: 600, leave: 100 }">
        <home-forecast v-show="showForecast" :forcasts="allWeather.data" :tempType="tempType"></home-forecast>
      </transition>
    </div>
    <filter-buttons></filter-buttons>
  </div>

</template>

<script>
  import FilterButtons from './HomeFilterButtons.vue'
  import geolib from 'geolib'
  import HomeForecast from './HomeForecast'
  import { mapState } from 'vuex'

  export default {
    props: [
      'showForecast',
      'toggleForecast'
    ],
    components: {
      HomeForecast,
      FilterButtons
    },
    computed: {
      ...mapState({
        allWeather: state => state.weather,
        user: state => state.user
      }),
      currentWeather: function () {
        return (this.allWeather.data) ? this.allWeather.data[0] : null
      },
      isUserLoggedOut () {
        return this.$store.getters.isUserLoggedOut
      },
      isTokenExpired () {
        return this.$store.getters.isTokenExpired
      },
      user () {
        return this.$store.getters.user
      },
      weatherRegions () {
        return this.$store.getters.weatherRegions
      },
      calculateTemp () {
        if (this.user && this.user.profile.unit_temperature === 'F') {
          this.tempType = 'F'
          return this.conversionCToF(this.currentWeather.json_object.main.temp)
        } else {
          this.tempType = 'C'
          return Math.round(this.currentWeather.json_object.main.temp)
        }
      },
      calculateWind () {
        if (this.user && this.user.profile.unit_wind === 'kn') {
          this.windType = 'kn'
          return this.conversionKmHToKn(this.windSpeed(this.currentWeather.json_object.wind.speed))
        } else {
          this.windType = 'km/h'
          return this.windSpeed(this.currentWeather.json_object.wind.speed)
        }
      }
    },
    mounted: function () {
      this.$store.dispatch('getWeatherRegions').then((response) => {
        if (!this.isUserLoggedOut) {
          this.$store.dispatch('getUserInfo').then((response) => {
            this.$store.dispatch('getWeatherData', this.$store.state.user.profile.weather_region_id)
          })
        } else {
          if (navigator.geolocation) {
            this.geolocation()
          } else {
            console.log('Not available geolocation')
            this.$store.dispatch('getWeatherData', 1)
          }
        }
      })
    },
    data: function () {
      return {
        tempType: 'C',
        windType: 'km/h'
      }
    },
    methods: {
      conversionCToF (temp) {
        return Math.round((temp * 1.8) + 32)
      },
      conversionKmHToKn (wind) {
        return Math.round((wind / 1.852))
      },
      toggle: function () {
        this.showForecast = !this.showForecast
        document.body.classList.toggle('forecastShown')
      },
      populateWeatherIcon (weather) {
        return '/static/img/weather/' + weather[0].icon + '.svg'
      },
      windSpeed: function (speed) {
        return Math.round(speed * 3.6)
      },
      getRegions () {
        let regions = {}
        this.weatherRegions.forEach(element => {
          regions[element.id] = {
            latitude: element.latitude,
            longitude: element.longitude
          }
        })
        // console.log(regions)
        return regions
      },
      geolocation () {
        navigator.geolocation.getCurrentPosition(this.buildUrl, this.geoError)
      },
      buildUrl (position) {
        let location = geolib.findNearest(
          {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          }, this.getRegions(), 1)

        this.$store.dispatch('getWeatherData', location.key)
      },
      geoError (error) {
        console.log(error)
        // Default back to Durban weather
        this.$store.dispatch('getWeatherData', 1)
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/home/HomeWeather.vue